import React from 'react';
import { Link } from 'react-router-dom';
import { person } from '../data/site';
import useTheme from '../utils/useTheme';

export default function Footer() {
  const { theme, toggleTheme } = useTheme();
  return (
    <footer className="personal-footer">
      <div className="footer-details">
        <span>© {new Date().getFullYear()} {person.name}</span>
        <button className="personal-theme" type="button" onClick={toggleTheme}
          aria-label={`Switch to ${theme === 'dark' ? 'light' : 'dark'} mode`}>
          {theme === 'dark' ? 'Light' : 'Dark'} mode
        </button>
      </div>
      <Link to="/experiments">Experiments</Link>
    </footer>
  );
}
